import * as React from "react";
const SvgPlayButton = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.564 2.229C6.56 2.227 6.557 6.624 6.557 12c0 5.376.003 9.773.007 9.771.015-.005 13.26-9.766 13.26-9.771 0-.005-13.245-9.766-13.26-9.771zm1.5 2.972.022.014c.08.053 9.2 6.778 9.2 6.785 0 .006-9.119 6.732-9.2 6.785l-.022.014V12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgPlayButton;
